import type { FC, SVGProps } from 'react'

export const ConnectKitLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 200 200"
    {...props}
  >
    <title>ConnectKit</title>
    <g transform="translate(0,200) scale(0.1,-0.1)" fill="#000" stroke="none">
      <path d="M0 1000 l0 -1000 1000 0 1000 0 0 1000 0 1000 -1000 0 -1000 0 0 -1000z m675 591 c45 -20 92 -71 108 -115 l10 -28 12 28 c59 140 232 177 337 72 21 -21 40 -49 44 -63 8 -33 16 -32 33 6 44 101 168 146 268 98 150 -73 158 -269 15 -355 l-52 -32 29 -12 c16 -6 43 -26 61 -43 102 -99 74 -263 -55 -329 -39 -21 -39 -21 -15 -30 42 -16 89 -58 110 -98 21 -42 27 -121 11 -163 -14 -35 -69 -95 -105 -114 -40 -21 -132 -21 -172 0 -37 19 -91 79 -105 115 l-10 26 -18 -40 c-37 -82 -139 -134 -226 -114 -55 13 -116 59 -139 107 l-20 41 -30 -51 c-102 -170 -355 -114 -373 82 -7 78 20 139 82 181 24 17 48 30 54 30 23 0 8 16 -32 36 -83 41 -127 148 -97 239 16 49 66 104 113 125 l39 17 -29 10 c-102 36 -161 167 -119 266 16 41 71 96 111 113 43 19 113 17 160 -5z" />
      <path d="M687 1312 c-15 -16 -17 -53 -17 -308 0 -216 3 -295 13 -307 11 -16 39 -17 322 -15 l310 3 3 310 c2 283 1 311 -15 323 -12 9 -91 12 -308 12 -270 0 -293 -1 -308 -18z" />
    </g>
  </svg>
)
